// index.js or App.js
import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import './i18n'; // Import the i18n configuration

function App() {
  return <RouterProvider router={router} />;
}

export default App;
